import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVolumeDownFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-224.00 -348.44 1600.00 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M768 1184V96Q768 70 749.0 51.0Q730 32 704.0 32.0Q678 32 659 51L326 384H64Q38 384 19.0 403.0Q0 422 0 448V832Q0 858 19.0 877.0Q38 896 64 896H326L659 1229Q678 1248 704.0 1248.0Q730 1248 749.0 1229.0Q768 1210 768 1184ZM997 405Q987 400 972 400Q946 400 927.0 418.5Q908 437 908 464Q908 485 920.0 499.5Q932 514 949.0 524.5Q966 535 983.0 547.5Q1000 560 1012.0 583.5Q1024 607 1024.0 640.0Q1024 673 1012.0 696.5Q1000 720 983.0 732.5Q966 745 949.0 755.5Q932 766 920.0 780.5Q908 795 908 816Q908 843 927.0 861.5Q946 880 972 880Q987 880 997 875Q1067 848 1109.5 782.0Q1152 716 1152.0 640.0Q1152 564 1109.5 498.5Q1067 433 997 405Z"
	})
});
export default SvgVolumeDownFill;
